if(typeof react-native === 'undefined') { var e = new Error("Cannot find module 'react-native'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = react-native;